export default __webpack_public_path__ + "static/ekyc-solution-digipay-guru-1c187121d6e8f8c5f310323bfd89311c.png";